import styled from 'styled-components';

import { richTextStyles } from '../../../atoms/typography';
import { spacing } from '../../../atoms/spacing';
import { atMinWidth } from '../../../atoms/breakpoints';
import { containers } from '../../../atoms/containers';
import { color } from '../../../atoms/colors';

export const Section = styled.section`
  position: relative;
  width: 100%;
  padding: ${spacing[48]} ${spacing[0]};

  ${atMinWidth.sm`
    padding: ${spacing[64]} ${spacing[0]} ${spacing[72]};
  `}

  ${atMinWidth.xl`
    padding: ${spacing[64]} ${spacing[0]} ${spacing[96]};
  `}
`;

export const Wrapper = styled.div`
  width: 100%;
  max-width: ${containers.md};

  display: flex;
  flex-direction: column;
  gap: ${spacing[32]};

  padding: ${spacing[0]} ${spacing[16]};
  margin: ${spacing[0]} auto;

  ${atMinWidth.sm`
    padding: ${spacing[0]} ${spacing[32]};
  `}

  ${atMinWidth.xl`
    max-width: ${containers.xl};
    display: grid;
    grid-template-columns: 40px 1fr;
    gap: ${spacing[32]};

    &[data-has-sidebar-content='true'] {
      grid-template-columns: 40px 1fr 384px;
    }
  `}
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[32]};

  ${atMinWidth.xl`
    display: block;
  `}

  .social-share {
    ${atMinWidth.xl`
      position: sticky;
      top: 96px;
    `}
  }
`;

export const RichText = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing[16]};
  z-index: 2;
  ${richTextStyles}

  p {
    color: ${color.darkBlue[600]};
  }
`;

export const Sidebar = styled.aside`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${spacing[32]};

  ${atMinWidth.xl`
    padding-left: ${spacing[60]};
  `}
`;
